// Shared Weather helpers — keeps WMO code → icon/label mapping in one place
import { CloudRain, Sun, Cloud, CloudSnow, CloudLightning, CloudDrizzle } from 'lucide-react';

export const WMO_CODES = {
  0: { label: 'Clear', Icon: Sun, color: 'text-amber-500' },
  1: { label: 'Mostly Clear', Icon: Sun, color: 'text-amber-400' },
  2: { label: 'Partly Cloudy', Icon: Cloud, color: 'text-stone-400' },
  3: { label: 'Overcast', Icon: Cloud, color: 'text-stone-500' },
  45: { label: 'Fog', Icon: Cloud, color: 'text-stone-400' },
  48: { label: 'Fog', Icon: Cloud, color: 'text-stone-400' },
  51: { label: 'Light Drizzle', Icon: CloudDrizzle, color: 'text-blue-400' },
  53: { label: 'Drizzle', Icon: CloudDrizzle, color: 'text-blue-500' },
  55: { label: 'Heavy Drizzle', Icon: CloudRain, color: 'text-blue-600' },
  61: { label: 'Light Rain', Icon: CloudRain, color: 'text-blue-500' },
  63: { label: 'Rain', Icon: CloudRain, color: 'text-blue-600' },
  65: { label: 'Heavy Rain', Icon: CloudRain, color: 'text-red-500' },
  71: { label: 'Light Snow', Icon: CloudSnow, color: 'text-blue-300' },
  73: { label: 'Snow', Icon: CloudSnow, color: 'text-blue-400' },
  75: { label: 'Heavy Snow', Icon: CloudSnow, color: 'text-blue-500' },
  80: { label: 'Rain Showers', Icon: CloudRain, color: 'text-blue-500' },
  81: { label: 'Rain Showers', Icon: CloudRain, color: 'text-blue-600' },
  82: { label: 'Heavy Showers', Icon: CloudRain, color: 'text-red-500' },
  95: { label: 'Thunderstorm', Icon: CloudLightning, color: 'text-red-600' },
  96: { label: 'Thunderstorm + Hail', Icon: CloudLightning, color: 'text-red-600' },
  99: { label: 'Severe Storm', Icon: CloudLightning, color: 'text-red-700' },
};

export const getWeatherInfo = (code) =>
  WMO_CODES[code] || { label: 'Forecast', Icon: Cloud, color: 'text-stone-400' };

// Look up forecast for a given YYYY-MM-DD string from weatherDaily state.
// weatherDaily = { dates: [...], probs: [...], codes: [...], tmax: [...], tmin: [...] }
// Returns { code, info, tmax, tmin, prob } or null if date not in window.
export const lookupForecast = (weatherDaily, dateStr) => {
  if (!weatherDaily || !dateStr) return null;
  const idx = weatherDaily.dates.indexOf(dateStr.slice(0, 10));
  if (idx === -1) return null;
  const code = weatherDaily.codes[idx];
  return {
    code,
    info: getWeatherInfo(code),
    tmax: weatherDaily.tmax?.[idx],
    tmin: weatherDaily.tmin?.[idx],
    prob: weatherDaily.probs?.[idx] || 0,
  };
};
